import CustomSelectListInput from '../CustomSelectListInput'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Alert } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { stringifyInputs } from '../CustomUtils'
import { enterKeyHandler } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function PlaintiffFirmReportForm({ location }) {
  console.log('PlaintiffFirmReportForm rendered: ', location)

  const init = {
    reportType: '1',
    settlementGroup: [],
    waveGroupType: [],
    surgeon: '',
    facility: ''
  }

  const navigate = useNavigate()
  const [toggle, setToggle] = useState(1)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('PlaintiffFirmReportForm.submitSearch', inputs)

    console.log(inputs.settlementGroup)
    let validInput = inputs.settlementGroup.length > 0 ? true : false

    if (!validInput) {
      return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}>Must select a "Settlement Group"</Alert></td></tr>)
    }
    let queryString = `/custom/plaintiff_firm.claimant_report?inputs=${stringifyInputs(inputs)}`
    navigate(queryString)
  }

  let tableBody =
    <tbody>
      <CustomSelectListInput label="Settlement Group" handleChange={handleInputChange} modelName="BosSci" entityName="settlement_group" name='settlementGroup' multiple={true} defaultValue={inputs.settlementGroup} />
    </tbody>

  console.log(toggle)
  if (toggle === '4') {
    tableBody =
      <tbody>
        <CustomSelectListInput label="Settlement Group" handleChange={handleInputChange} modelName="BosSci" entityName="settlement_group" name='settlementGroup' multiple={true} defaultValue={inputs.settlementGroup} />
        <TextInput label='Surgeon' name='surgeon' handleInputChange={handleInputChange} />
        <TextInput label='Facility' name='facility' handleInputChange={handleInputChange} />
        <CustomSelectListInput label="Wave/Group Type" modelName="BosSci" entityName="segment" name="waveGroupType" handleChange={handleInputChange} multiple={true} />
      </tbody>
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <thead>
              <tr><th colSpan="2" className="custom-table-header">
                Plaintiff Firm Report
                <span><br /></span>
                <Input
                  type="select"
                  name="reportType"
                  onChange={(e) => {
                    setToggle(e.target.value)
                    handleInputChange(e)
                  }}
                  style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                >
                  <option value={'1'}>Plaintiff Info Tab Report</option>
                  <option value={'2'}>Classification Info Tab Report</option>
                  <option value={'3'}>Entire Inventory Report</option>
                  <option value={'4'}>Surgeon Report</option>
                </Input></th>
              </tr>
            </thead>
            {formFeedback}
            {tableBody}
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

